/** Cap do multiplicador — acima disso é provável mis-scan (não multiplica). */
const MAX_MULTIPLICADOR = 9999;

/**
 * Interpreta a entrada da barra de bipagem quando o multiplicador está ligado.
 *
 * Reconhece o prefixo `N*código` / `N x código` (aceita `*`, `x`, `X`, com espaços opcionais
 * ao redor do separador). `N` vai de 1 a 9999; fora disso — ou sem prefixo reconhecível —
 * devolve `{ multiplicador: 1, codigo }` (código cru, comportamento normal da bipagem).
 *
 * Um EAN puro (só dígitos) NUNCA casa o ramo de multiplicação: o regex exige o separador e
 * algo depois dele. Assim ligar a feature não muda como um código de barras comum é lido.
 */
export function parseEntradaBipagem(texto: string): { multiplicador: number; codigo: string } {
  const limpo = texto.trim();
  const m = /^(\d{1,4})\s*[*xX]\s*(.+)$/.exec(limpo);
  if (m) {
    const n = Number(m[1]);
    if (n >= 1 && n <= MAX_MULTIPLICADOR) return { multiplicador: n, codigo: m[2].trim() };
  }
  return { multiplicador: 1, codigo: limpo };
}
